"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _DOCUMENT_TYPES_LABEL;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DOCUMENT_TYPES = __importStar(require("./types"));

var DOCUMENT_TYPES_LABELS = (_DOCUMENT_TYPES_LABEL = {}, _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.ADDITION, "Additional"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.ADD_EMPLOYMENT_BUSINESS, "Additional Employment/Business"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.AMENDMENT, "Amendment"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.CERTIFICATE_OF_COMPLETION, "Certificate of Completion"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.CERTIFICATE_OF_COUNSELING, "Certificate of Counseling"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.CREDITOR_MATRIX, "Creditor Matrix"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.CREDIT_REPORT, "Credit Report"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.ESIGN, "E-Sign"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.FORM_101_A, "Eviction Judgment"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.FORM_103, "Fee Waiver"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.JUDGMENT, "Judgments"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.LOCAL_FORMS, "District Forms"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.MEDICAL_RECORD, "Medical Bills"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.PACKET_FILING, "Filing Packet"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.PACKET_TRUSTEE, "Trustee Packet"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.PAY_ADVICES, "Pay Stubs"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.PAY_DAY_LOAN, "Pay Day Loans"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.PAY_STUB, "Pay Stub"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.PETITION, "Docassemble Petition"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.SUPPORT_DOCUMENTS, "Support Documents"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.TAX_RETURN, "Tax Returns"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.TAX_RETURN_REQUEST, "4506-T Request Form"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.UTILITY, "Utilities"), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.STUDENT_LOANS_NSLDS_REPORT, "NSLDS"), _DOCUMENT_TYPES_LABEL);
exports.default = DOCUMENT_TYPES_LABELS;